import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PublicForm from "../components/PublicForm";
import QRinfo from "../components/QRinfo";
import kumbhImage from "../kumbh.jpg";
import Navbar from "../components/Navbar"; // Import the Navbar component
import "../styles.css"; 

const Home = () => {
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(false);
  const [showQRinfo, setShowQRinfo] = useState(false);

  const handleCloseForm = () => {
    setShowForm(false);
    setShowQRinfo(false);
  };

  return (
    <div>
      <Navbar />
      <div className="image-container">
        <img src={kumbhImage} alt="Home Background"/>
        <div>
          {!showForm && !showQRinfo ? (
            <div className="button-container">
              {/* Removed the "Register Here" button */}
            </div>
          ) : showForm ? (
            <PublicForm onClose={handleCloseForm} />
          ) : (
            <QRinfo/>
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;
